// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3EgKD","balanceDisclaimer":"posDashboard_balanceDisclaimer__3Eu78"};